import { Component, OnInit, Renderer2, ElementRef } from '@angular/core';

declare var $: any;

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    constructor(private renderer: Renderer2, private el: ElementRef) { }

    ngOnInit(): void {
        this.setupPopupSearchBox('.popup-search-box', '.searchBoxToggler', '.searchClose', 'show');
        this.setupPopupSideMenu('.sidemenu-wrapper', '.sideMenuToggler', '.sideMenuCls', 'show');
        this.setupPopupSideMenu('.shopping-cart', '.sideMenuToggler2', '.sideMenuCls', 'show');

        // Set background images
        if ($("[data-bg-src]").length > 0) {
            $("[data-bg-src]").each(function () {
                const src = $(this).attr("data-bg-src");
                $(this).css("background-image", "url(" + src + ")");
                $(this).removeAttr("data-bg-src").addClass("background-image");
            });
        }

        if ($('.portfolio-menu button').length > 0) {
            $('.portfolio-menu button').on('click', function (event) {
                $(this).siblings('.active').removeClass('active');
                $(this).addClass('active');
                event.preventDefault();
            });
        }
    }

    private setupPopupSearchBox(
        searchBoxSelector: string,
        openBtnSelector: string,
        closeBtnSelector: string,
        toggleClass: string
    ): void {
        const searchBox = $(searchBoxSelector);
        const openBtn = $(openBtnSelector);
        const closeBtn = $(closeBtnSelector);

        // Open search box
        $(document).on('click', openBtnSelector, (e: Event) => {
            e.preventDefault();
            searchBox.addClass(toggleClass);
        });

        // Close on clicking outside
        $(document).on('click', (e: any) => {
            if (!$(e.target).closest(searchBoxSelector).length && !$(e.target).closest(openBtnSelector).length) {
                searchBox.removeClass(toggleClass);
            }
        });

        // Prevent form click from closing box
        $(document).on('click', `${searchBoxSelector} form`, (e: Event) => {
            e.stopPropagation();
            searchBox.addClass(toggleClass);
        });

        // Close button
        $(document).on('click', closeBtnSelector, (e: Event) => {
            e.preventDefault();
            e.stopPropagation();
            searchBox.removeClass(toggleClass);
        });
    }

    private setupPopupSideMenu(
        menuSelector: string,
        openBtnSelector: string,
        closeBtnSelector: string,
        toggleClass: string
    ): void {
        const menu = $(menuSelector);
        const openBtn = $(openBtnSelector);
        const closeBtn = $(closeBtnSelector);

        // Open menu
        $(document).on('click', openBtnSelector, (e: Event) => {
            e.preventDefault();
            menu.addClass(toggleClass);
        });

        // Close on clicking outside
        $(document).on('click', (e: any) => {
            if (!$(e.target).closest(menuSelector).length && !$(e.target).closest(openBtnSelector).length) {
                menu.removeClass(toggleClass);
            }
        });

        // Prevent close when clicking inside menu
        $(document).on('click', `${menuSelector} > div`, (e: Event) => {
            e.stopPropagation();
            menu.addClass(toggleClass);
        });

        // Close with close button
        $(document).on('click', closeBtnSelector, (e: Event) => {
            e.preventDefault();
            e.stopPropagation();
            menu.removeClass(toggleClass);
        });
    }
}